export default "__VITE_ASSET__C6iIw6oN__"